import { getAccessToken, login, service } from "../server/request";
import { setItemToSessionStore, setItemToStore, MANAGE_STORE, STORE_TYPE } from "../helpers/utils";

export const loginUser = async (dispatch, loginPayload) => {
  try {
    dispatch({ type: "REQUEST_LOGIN" });
    const resp = await getAccessToken({
      userName: loginPayload.userName,
      password: loginPayload.password,
    });
    if (resp.data) {
      const loginResp = await login({ token: resp.data.access_token });
      if (loginResp.data) {
        const _payload = { authInfo: resp.data, otherInfo: loginResp.data };
        await dispatch({ type: "LOGIN_SUCCESS", payload: _payload });
        if (MANAGE_STORE == STORE_TYPE.SS) {
          setItemToSessionStore("currentUser", _payload);
          setItemToSessionStore("isNutritionEnabled", true);
        } else {
          setItemToStore("currentUser", _payload);
          setItemToStore("isNutritionEnabled", true);
        }
        return _payload;
      }
    } else {
      dispatch({ type: "LOGIN_ERROR", error: "Invalid Username/password" });
      return undefined;
    }
  } catch (error) {
    const errorObject = error.toJSON();
    const errorMessage =
      errorObject.message === "Request failed with status code 401"
        ? "Invalid Username/Password"
        : errorObject.message;
    await dispatch({ type: "LOGIN_ERROR", error: errorMessage });
    return { error: true, errorMessage };
  }
};

export const loginWithSingleSignin = async (dispatch, loginPayload) => {
  try {
    dispatch({ type: "REQUEST_LOGIN" });
    const loginResp = await login({ token: loginPayload.access_token, id: 0 });
    if (loginResp.data) {
      const _payload = {
        authInfo: { ...loginPayload },
        otherInfo: loginResp.data,
      };
      await dispatch({ type: "LOGIN_SUCCESS", payload: _payload });
      if (MANAGE_STORE == STORE_TYPE.SS) {
        setItemToSessionStore("currentUser", _payload);
      } else {
        setItemToStore("currentUser", _payload);
      }
      return _payload;
    }
  } catch (error) {
    const errorObject = error.toJSON();
    const errorMessage =
      errorObject.message === "Request failed with status code 401"
        ? "Invalid Username/Password"
        : errorObject.message;
    await dispatch({ type: "LOGIN_ERROR", error: errorMessage });
    return { error: true, errorMessage };
  }
};

export const findByMail = async (mail) => {
  try {
    const url = `/mealManage/usersAuthInfoes/search/validateUserName?username=${mail}`;
    const resp = await service({
      method: "GET",
      url: url,
    });
    if (resp.status === 200) {
      return { success: true, data: resp.data };
    }
  } catch (ex) {
    return { error: true, errorMessage: ex.errorMessage };
  }
};
export const submitForgetPassword = async (req) => {
  try {
    const url = `/mealManage/forgotPassword`;
    const resp = await service({
      method: "POST",
      url: url,
      data: req,
    });
    if (resp.status === 200) {
      return { success: true, data: resp.data };
    }
  } catch (ex) {
    return { error: true, errorMessage: ex.errorMessage };
  }
};
export const changePassword = async (req) => {
  try {
    const url = `/mealManage/recoveryPassword?isCaterer=true`;
    const resp = await service({
      method: "POST",
      url: url,
      data: req,
    });
    if (resp.status === 200) {
      return { success: true, data: resp.data };
    }
  } catch (ex) {
    return { error: true, errorMessage: ex.errorMessage };
  }
};

export const validateResetPwdToken = async ({ token, uid }) => {
  try {
    const url = `/mealManage/isLinkValidate?token=${token}&userId=${uid}&isCaterer=true`;
    const resp = await service({
      method: "GET",
      url: url,
    });
    if (resp.status === 200) {
      return { success: true, data: resp.data };
    }
  } catch (ex) {
    return { error: true, errorMessage: ex.errorMessage };
  }
};

export const logout = (dispatch) => {
  try {
    if (MANAGE_STORE == STORE_TYPE.SS) {
      setItemToSessionStore("currentUser", JSON.stringify({}));
    } else {
      setItemToStore("currentUser", JSON.stringify({}));
    }
  } catch (ex) { }
  return true;
};
